import React from 'react';
import PropTypes from 'prop-types';
import ComplexTable from 'components/shared/table/ComplexTable';
import './TasksReviewTable.css';
import Number from 'components/shared/text/Number';
import CheckBox from 'components/shared/checkbox/CheckBox';
import numeral from 'numeral';

export default function TasksReviewTable(props) {
  const handleSelection = (id) => {
    if (props.onSelection) {
      props.onSelection(id);
    }
  };

  const headers = [];
  if (props.showSelection) {
    headers.push('');
  }
  headers.push('TASK');
  headers.push('DETAILS');
  headers.push('MATERIAL LEAD TIME');
  if (props.showContractor) {
    headers.push('CONTRACTOR');
  }
  headers.push('COST');

  return (
    <div className="tasks-review-table-container">
      <ComplexTable
        className={`tasks-review-table${
          props.showContractor ? ' with-contractor' : ''
        }${props.showSelection ? ' with-selection' : ''}`}
        emptyMessage=""
        headers={headers}
        rows={valueRows(props, handleSelection)}
      />
    </div>
  );
}

function valueRows(props, handleSelection) {
  let rows = [];
  props.values.forEach((item, index) => {
    const row = [];
    if (props.showSelection) {
      row.push(
        <div className="with-check-box">
          <CheckBox
            id={item.id}
            checked={item.selected}
            shape="round"
            size="medium"
            onChange={handleSelection}
          />
        </div>
      );
    }
    row.push(<span className="body-bold">#{item.number}</span>);
    row.push(<span className="body-bold">{item.details}</span>);
    row.push(<span className="body-bold">{item.materialLeadTime}</span>);
    if (props.showContractor) {
      row.push(item.contractor);
    }
    row.push(
      <span className="body-bold">
        <Number value={item.cost} format="$0,0.00" />
      </span>
    );
    rows.push(row);
    if (item.breakdownItems && item.breakdownItems.length > 0) {
      rows.push([
        <table
          className={`breakdownItemsTable ${
            props.showSelection ? ' with-selection' : ''
          }`}
        >
          <colgroup>
            <col key={1} />
            <col key={2} />
            <col key={3} />
            <col key={4} />
            <col key={5} />
            {props.showSelection && <col key={6} />}
          </colgroup>
          <thead>
            <tr>
              {props.showSelection && (
                <th>
                  <span>&nbsp;</span>
                </th>
              )}
              <th>
                <span>&nbsp;</span>
              </th>
              <th>
                <span>DETAILS</span>
              </th>
              <th>
                <span>UNITS</span>
              </th>
              <th>
                <span>COST</span>
              </th>
              <th>
                <span>EXT</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {item.breakdownItems.map((bi, index) => {
              return (
                <tr key={index}>
                  {props.showSelection && (
                    <td>
                      <span>&nbsp;</span>
                    </td>
                  )}
                  <td>
                    <span>&nbsp;</span>
                  </td>
                  <td>
                    <span className="body-regular">{bi.concept}</span>
                  </td>
                  {numeral(bi.ext).value() > 0 && (
                    <React.Fragment>
                      <td>
                        <span className="body-regular">
                          {bi.unit_number}&nbsp;{bi.unit_type}
                        </span>
                      </td>
                      <td>
                        <span className="body-regular">
                          <Number value={bi.cost} format="$0,0.00" />
                        </span>
                      </td>
                      <td>
                        <span className="body-regular">
                          <Number value={bi.ext} format="$0,0.00" />
                        </span>
                      </td>
                    </React.Fragment>
                  )}
                  {numeral(bi.ext).value() === 0 && (
                    <React.Fragment>
                      <td colSpan={2}></td>
                      <td>
                        <span className="body-regular">Included</span>
                      </td>
                    </React.Fragment>
                  )}
                </tr>
              );
            })}
            <tr>
              {props.showSelection && (
                <td>
                  <span>&nbsp;</span>
                </td>
              )}
              <td>
                <span>&nbsp;</span>
              </td>
              <td>
                <span className="body-regular">OH&P</span>
              </td>
              <td>
                <span className="body-regular">
                  <Number
                    value={(item.markup + item.fee) / item.cost}
                    format="0.00 %"
                  />
                </span>
              </td>
              <td>
                <span className="body-regular">
                  <Number value={item.cost} format="$0,0.00" />
                </span>
              </td>
              <td>
                <span className="body-regular">
                  <Number value={item.markup + item.fee} format="$0,0.00" />
                </span>
              </td>
            </tr>
            <tr>
              {props.showSelection && (
                <td>
                  <span>&nbsp;</span>
                </td>
              )}
              <td>
                <span>&nbsp;</span>
              </td>
              <td>
                <span className="body-regular">Insurance</span>
              </td>
              <td>
                <span className="body-regular">
                  <Number value={item.insurance / item.cost} format="0.00 %" />
                </span>
              </td>
              <td>
                <span className="body-regular">
                  <Number value={item.cost} format="$0,0.00" />
                </span>
              </td>
              <td>
                <span className="body-regular">
                  <Number value={item.insurance} format="$0,0.00" />
                </span>
              </td>
            </tr>
          </tbody>
        </table>,
      ]);
    }
  });
  return rows;
}

TasksReviewTable.propTypes = {
  showContractor: PropTypes.bool,
  showSelection: PropTypes.bool,
  values: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      number: PropTypes.number.isRequired,
      details: PropTypes.string.isRequired,
      contractor: PropTypes.string,
      cost: PropTypes.number.isRequired,
      selected: PropTypes.bool,
    })
  ),
  onSelection: PropTypes.func,
};

TasksReviewTable.defaultProps = {
  showContractor: false,
  showSelection: false,
  values: [],
};



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/proposals/TasksReviewTable.js